// Core imports
import React from 'react';
import PropTypes from 'prop-types';

// Component imports
import { Avatar, Card, Col, Grid, Row, Typography } from 'antd';
import OrgPlaceholderImage from '../../assets/placeholder_organization.svg';

// Constant declarations
const { useBreakpoint } = Grid;

const HelviaCard = ({
  rightSideContent,
  leftSideContent,
  className,
  org,
  ...restProps
}) => {
  const screens = useBreakpoint();
  const isTabletSize = !screens.xl && !screens.xxl;

  return (
    <Card className={`border-0 p-0 ${className}`} {...restProps}>
      <Row>
        <Col className="d-flex flex-column" xs={isTabletSize ? 24 : 10}>
          {
            org?.loginSettings ? (
              <Row className="m-5" justify={'start'}>
                {
                  org?.loginSettings != null && (
                    <Col span={12}>
                      <span className="d-flex align-items-center float-right">
                        {
                          org?.loginSettings?.isOrganizationLogoVisible ? (
                            <Avatar
                              size={24}
                              shape="square"
                              src={org.image ?? OrgPlaceholderImage}
                              className="bordered flex-none"
                            />
                          ) : null
                        }

                        {
                          org?.loginSettings?.isOrganizationNameVisible && Boolean(org.displayName) ? (
                            <Typography.Text ellipsis={true} className="ml-3 fs-lg">
                              {org.displayName}
                            </Typography.Text>
                          ) : null
                        }
                      </span>
                    </Col>
                  )
                }
              </Row>
            ) : null
          }

          <Row>
            <Col className="d-flex justify-content-center" span={24}>
              {leftSideContent}
            </Col>
          </Row>
        </Col>

        {
          !isTabletSize ? (
            <Col xs={14} className="helvia-card-right flex-column position-relative">
              {rightSideContent}
            </Col>
          ) : null
        }
      </Row>
    </Card>
  );
};

HelviaCard.propTypes = {
  rightSideContent: PropTypes.any,
  leftSideContent: PropTypes.any,
  className: PropTypes.string,
  org: PropTypes.object
};

export default HelviaCard;
